import {RequestInfo} from "@khan/shared-core";

export function shouldInitAnalytics() {
    return (
        !RequestInfo.embedded &&
        !RequestInfo.IS_DEV_SERVER &&
        !RequestInfo.isE2E &&
        // eslint-disable-next-line no-restricted-syntax -- we never want to have analytics on the pwreset page
        window.location.pathname !== "/pwreset"
    );
}
